import React from 'react'
import { PrismicLink, PrismicRichText } from '@prismicio/react'

const Text = ({ slice }) => {
  return (
    <section
      className={`component-${slice.slice_type} ${slice.primary.columns === true && 'columns sm:px-12 md:px-20'} ${
        slice.primary.background === true ? 'border-t border-b border-dotted border-gray-700 py-10 sm:py-16 bg-indigo-700' : 'py-8 md:pb-16'
      } px-8`}>
      <div className={`${slice.primary.columns === true ? 'mx-auto max-w-screen-xl' : 'max-w-4xl mx-auto'}`}>
        {slice.primary.title.text && (
          <div className={`mb-8 ${slice.primary.background === true && 'text-white'}`}>
            <PrismicRichText field={slice.primary.title.richText} />
          </div>
        )}
        <div className={`prose prose-lg dark:prose-invert ${slice.primary.columns === true ? 'min-w-full' : 'max-w-4xl mx-auto'} ${slice.primary.background === true && 'prose-invert'} `}>
          <PrismicRichText field={slice.primary.text.richText} />
        </div>
        {slice.primary.button_link?.url && slice.primary.button_text && (
          <div className={`flex justify-center mx-auto mt-5 ${slice.primary.background === true && 'text-white'}`}>
            <PrismicLink className={`button ${slice.primary.background === true && 'hover:bg-indigo-600'}`} field={slice.primary.button_link}>
              {slice.primary.button_text}
            </PrismicLink>
          </div>
        )}
      </div>
    </section>
  )
}

export default Text
